import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/hd49XcQQXdBfWYLHLNAsN4/ChatGPT_Image_11_sept_2026__15_26_24-removebg-preview.webp';
export function Hero() {
  return <section id="hero" className="w-full bg-[#F5F6F7] px-6 py-16 sm:px-10 lg:py-20" data-id="element-83" data-mp="4m8nkg2xoxmi">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-84" data-mp="129h0hmovcycw">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-85" data-mp="1274nzp1vrg78">
          <h1 className="font-heading text-4xl font-bold leading-tight text-[#287C65] sm:text-5xl" data-id="element-86" data-mp="s9ggrzn38g86">
            ¿Cansada de sentirte hinchada y sin energía?
          </h1>

          <p className="mt-6 text-base text-[#374151] sm:text-xl" data-id="element-87" data-mp="3d2l8r9xwn0zn">
            Descubre <span className="font-bold text-[#287C65]" data-id="element-88" data-mp="381xkgw128y94">245 recetas antiinflamatorias</span> pensadas para comer
            rico, variado y sin complicarte.
          </p>
        </motion.div>

        {/* LCP element: no entrance animation, so it paints immediately instead of fading in with the rest of the hero. */}
        <img src={MOCKUP_URL} alt="Pack completo Barriga Plana: 6 tomos de recetas antiinflamatorias más 5 bonos" width={1024} height={1024} fetchPriority="high" loading="eager" decoding="sync" className="mt-8 h-auto w-full max-w-[360px] sm:max-w-[420px]" data-id="element-89" data-mp="399b9bibx13tc" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-col items-center" data-id="element-90" data-mp="35au9zkyqkxmh">
          <a href="#comprar" className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-coral px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-coral-dark sm:w-auto sm:min-w-[300px]" data-id="element-91" data-mp="2hix0i0irehoj">
            Acceso Ahora — 19€
          </a>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-gray-600" data-id="element-92" data-mp="n9qj5b6u0w8h">
            <span className="flex items-center gap-1.5" data-id="element-93" data-mp="ici1dbpliu7r">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-94" data-mp="ddwzl7up42h7" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-95" data-mp="1azumdhg3ytyy">
              <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="161t1cqz4gkku" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-97" data-mp="112pur23hu6ar">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="111507ch6incw" /> Pago seguro
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}